<template>
  <div class="contactWay">
    <div class="middle">
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省嘉兴市经济技术开发区商务金融大厦1幢办C601室-B室
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司杭州分公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省杭州市西湖区学院路77号2幢1201室
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司桐庐分公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省杭州市桐庐县城南街道迎春南路205号新青年广场1501室-2、1501室-3
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司金华分公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省金华市金东区多湖街道宾虹东路358号嘉福商务大厦1幢103、105铺
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司义乌分公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省义乌市福田街道银海路399号国际商务中心1101室
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司绍兴分公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省绍兴市柯桥区柯桥街道绍兴世界贸易中心（南区）16幢四层B044号
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司诸暨分公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省诸暨市陶朱街道西二环路288号外贸大厦20层南区
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司海宁分公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省嘉兴市海宁市许村镇人民大道2838号和信大厦5楼501室
          </div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <div class="techTitle fz16"><span></span>壹心保险代理（浙江）有限公司桐乡分公司</div>
          <div class="techText">
            客服电话：400-000-2266 （周一至周五 09：00-17：00）<br>
            公司邮箱：Customer-zrbx@yxinsur.com<br>
            公司地址：浙江省嘉兴市桐乡市梧桐街道振兴东路(东)329号东湖金悦小区8幢19层
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contactWay',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.contactWay {
  width: 788px;
  box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 16px 24px 40px;

  .middle {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .middleItem {
      width: 360px;
      height: 194px;
      background: url('../assets/images/picture_32.png') no-repeat;
      background-size: 100%;
      padding: 20px;
      margin-top: 24px;
      position: relative;

      .techTitle {
        font-weight: 600;
        position: relative;
        padding-left: 16px;

        span {
          position: absolute;
          top: 3px;
          left: 0;
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #2488CA;
          border-radius: 2px;
        }
      }

      .techText {
        color: #666666;
        margin-top: 10px;
        line-height: 24px;
      }
    }
  }
}
</style>